import React from 'react';
import { BentoGridGallery, BentoGridItemGallery } from "./ui/bento-grid-gallery";
import { galleryData, items } from "../data/galleryData";
import { FaArrowRight } from "react-icons/fa";
import PageWrapper from "../components/PageWrapper";

const Gallery = () => {
  return (
    <PageWrapper>
      <div className="bg-gradient-to-b from-sky-100 via-white to-white py-12 sm:py-16 min-h-screen">
        <div className="mx-auto max-w-6xl lg:max-w-6xl px-2 sm:px-6 lg:px-4">
          {/* Header Section */}
          <h2 className="text-left text-base font-semibold text-sky-600">
            {galleryData.title}
          </h2>
          <h3 className="mt-2 max-w-lg text-balance text-left text-xl font-semibold tracking-tight text-gray-950">
            {galleryData.subtitle}
          </h3>

          {/* Bento Grid Section */}
          <BentoGridGallery className="max-w-6xl mx-auto mt-10">
            {items.map((item, i) => (
              <a href={item.link} key={i}>
                <BentoGridItemGallery
                  title={item.title}
                  imageSrc={item.imageSrc} // ✅ updated
                  description={
                    <div className="flex items-center gap-2">
                      <FaArrowRight className="text-black" />
                      <span>{item.description}</span>
                    </div>
                  }
                  className={i === 3 || i === 6 ? "md:col-span-2" : ""}
                />
              </a>
            ))}
          </BentoGridGallery>
        </div>
      </div>
    </PageWrapper>
  );
};

export default Gallery;
